export default __webpack_public_path__ + "static/media/info.36be6a24.svg";